import { gql, TypedDocumentNode } from "@apollo/client";

import { ConfigElement, MutationIntentProjectConfigUpdateArgs } from "types/generated";

export const INTENT_PROJECT_CONFIG_UPDATE: TypedDocumentNode<
  { intentProjectConfigUpdate: ConfigElement },
  MutationIntentProjectConfigUpdateArgs
> = gql`
  mutation IntentProjectConfigUpdate($project: ID!, $config: ConfigInput!) {
    intentProjectConfigUpdate(project: $project, config: $config) {
      id
      type
      value
    }
  }
`;
